import { TEAL, TEAL_LIGHT, SURFACE_1 } from '../theme/creamyTokens';
import { tealAccentTheme } from '../theme/appTheme';

/**
 * The /explore filters modal's sliders and the price histogram.
 *
 * These were four hand-written hex values that happened to equal the theme's
 * own -- the comment in creamyTokens even said so ("TEAL matches
 * FILTER_ACCENT_COLOR... kept as separate constants"). Two copies of a colour
 * are one colour and one future bug, so these are now aliases. The names stay
 * because the filters' own code reads better with them.
 */
export const FILTER_ACCENT_COLOR = TEAL;
export const FILTER_ACCENT_COLOR_LIGHT = TEAL_LIGHT;

/** Surface-1 cream for the histogram's out-of-range bars: visible against the modal's white background, unlike antd's near-transparent colorFillSecondary, and warm rather than a flat neutral gray. */
export const FILTER_INACTIVE_FILL = SURFACE_1;

export const filterSliderTheme = tealAccentTheme;
